import { useState } from 'react';

export type ConfirmModalType = 'warning' | 'danger' | 'info' | 'success';

interface ConfirmModalState {
  show: boolean;
  title: string;
  message: string;
  type: ConfirmModalType;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  loading?: boolean;
}

export const useConfirmModal = () => {
  const [modalState, setModalState] = useState<ConfirmModalState>({
    show: false,
    title: '',
    message: '',
    type: 'warning'
  });

  const showConfirm = (
    title: string,
    message: string,
    onConfirm: () => void,
    type: ConfirmModalType = 'warning',
    confirmText?: string,
    cancelText?: string
  ) => {
    setModalState({
      show: true,
      title,
      message,
      type,
      confirmText,
      cancelText,
      onConfirm,
      loading: false
    });
  };

  const hideConfirm = () => {
    setModalState(prev => ({
      ...prev,
      show: false,
      loading: false
    }));
  };

  const setLoading = (loading: boolean) => {
    setModalState(prev => ({
      ...prev,
      loading
    }));
  };

  const handleConfirm = async () => {
    if (modalState.onConfirm) {
      setLoading(true);
      try {
        await modalState.onConfirm();
        // Fechar o modal após sucesso
        hideConfirm();
      } catch (error) {
        console.error('Erro ao executar ação:', error);
        setLoading(false);
      }
    }
  };

  return {
    modalState,
    showConfirm,
    hideConfirm,
    setLoading,
    handleConfirm
  };
};
